import type { FaireProductEntity } from "../../entity_types/product";

export const p_qdxmgh4gnb: FaireProductEntity = {
  token: "p_qdxmgh4gnb",
  type: "product",
  name: "Anniversary Mix Tape Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/a92f73a1b8e0943d43087927ad4f93809e4834c290a3904c8cd1f367fb1c142f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/17631804a20a94c4ca83d21050067fe3ad70dbefc05129669081a1bf8a945b25.jpeg",
    "https://cdn.faire.com/fastly/d61936a0372cdfc07b5c0d2d7f9ae48191329f742177a6a97f2d150fde64bb63.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:24.623Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
